module.exports = __webpack_public_path__ + "img/img3.494a5961.png";